import { render } from "./OptionsMenu.vue?vue&type=template&id=a74ea1e2&scoped=true"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=a74ea1e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74ea1e2"]])

export default __exports__